import { IconOtherClose } from '@doltech/icons/IconOtherClose';
import { ContentItemGroupWithEditorGrammarLanding } from './ContentItemGroupWithEditorGrammarLanding';
import { TocContentLayout } from '@doltech/ui/lib/figma/Layout/Landing/Content/TableOfContent/TocContentLayout/TocContentLayout';
import { tableOfContentFlatMap } from '@doltech/ui/lib/figma/Layout/Landing/Content/TableOfContent/utils';
import { useTableOfContentScrollTracking } from '@doltech/ui/lib/figma/Layout/Landing/Content/useTableOfContentScrollTracking.hook';
import * as React from 'react';
import styled from 'styled-components';
import {
  ContentItemGroup
} from '@doltech/ui/lib/figma/Layout/Landing/Content/TableOfContent/ContentItemGroup/ContentItemGroup';
import { ResponsiveTypography } from '@doltech/ui/lib/figma/Typography/v3/ResponsiveTypography';

const CLOSE_BUTTON_SIZE = 24;

const CloseButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${CLOSE_BUTTON_SIZE}px;
  height: ${CLOSE_BUTTON_SIZE}px;
  min-width: ${CLOSE_BUTTON_SIZE}px;
  border-radius: 50%;
  cursor: pointer;
`;

const Header = styled.header`
  display: flex;
  align-items: flex-start;
  margin-bottom: 16px;

  .toc-title {
    flex: 1;
    margin-right: 12px;
  }
`;

const ContentWrapper = styled.div`
  overflow: auto;
  li {
    display: initial !important;
  }
`;

const Main = styled.nav``;

export const TOCFooter = (props) => {
  const { items, editorItems, scrollContainerElm, onClose } = props;

  const itemToCheck = items?.length ? items : editorItems;
  const sectionIds = React.useMemo(() => {
    return tableOfContentFlatMap(itemToCheck).map((item) => item.id);
  }, [itemToCheck]);
  const { currentSectionId } = useTableOfContentScrollTracking({
    sectionIds,
    scrollContainerElm,
    offsetY: 0,
  });

  return (
    <Main>
      <Header className="toc-header">
        <ResponsiveTypography.Title className="toc-title" variant="semi-bold/16-28" color="gray180">
          Nội dung bài viết
        </ResponsiveTypography.Title>
        <CloseButton onClick={onClose}>
          <IconOtherClose fontSize={20} />
        </CloseButton>
      </Header>

      <ContentWrapper className="toc-content">
        <TocContentLayout>
          {editorItems?.map((item) => (
            <ContentItemGroupWithEditorGrammarLanding
              key={item.id}
              onClick={onClose}
              currentSectionId={currentSectionId}
              scrollContainerElm={scrollContainerElm}
              {...item}
            />
          ))}
          {items?.map((item) => (
            <ContentItemGroup
              key={item.id}
              currentSectionId={currentSectionId}
              onClick={onClose}
              scrollContainerElm={scrollContainerElm}
              {...item}
            />
          ))}
        </TocContentLayout>
      </ContentWrapper>
    </Main>
  );
};
